import { NgModule } from '@angular/core';
import { QuestionModule } from '../abstract/question.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ClickOutsideModule } from '../../../../shared';

import { RegularCellModule } from './regular-cell/regular-cell.module';
import { NumberToAlphabetPipe } from './number-to-alphabet.pipe';
import { QuestionTableCheckboxComponent } from './question-table-checkbox.component';
import { HeaderCellComponent } from './header-cell/header-cell.component';

@NgModule({
  imports: [
    QuestionModule,
    RegularCellModule,
    ClickOutsideModule,
    BsDropdownModule.forRoot()
  ],
  declarations: [
    QuestionTableCheckboxComponent,
    NumberToAlphabetPipe,
    HeaderCellComponent
  ],
  exports: [QuestionTableCheckboxComponent]
})
export class QuestionTableCheckboxModule {}
